import { createSlice } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

const initialState = {
  isAuth: false,
  error: null,
  user: {
    pk: null,
    username: "",
    email: "",
    first_name: "",
    last_name: "",
    is_staff: false,
    is_active: false,
    date_joined: "",
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.isAuth = true;
      state.user = action.payload;
      state.error = false;

      // Update Sentry user context
      Sentry.setUser({
        username: action.payload.username,
        email: action.payload.email,
        id: action.payload.pk,
        is_staff: action.payload.is_staff,
        is_active: action.payload.is_active,
      });
    },
    logout(state) {
      localStorage.removeItem("access");
      localStorage.removeItem("refresh");
      state.isAuth = false;
      state.user = initialState.user;
      state.error = false;

      // Clear Sentry user context
      Sentry.setUser(null);
    },
    authError(state, action) {
      state.error = action.payload;
    },
  },
});

export const { login, logout, authError } = authSlice.actions;

export default authSlice.reducer;
